import type { ReactNode } from 'react'
import clsx from 'clsx'
import styles from './Card.module.css'

interface CardProps {
  children: ReactNode
  className?: string
  noPadding?: boolean
}

interface CardHeaderProps {
  title: ReactNode
  subtitle?: ReactNode
  actions?: ReactNode
  className?: string
}

interface CardContentProps {
  children: ReactNode
  className?: string
}

export function Card({ children, className, noPadding }: CardProps) {
  return (
    <div className={clsx(styles.card, noPadding && styles.noPadding, className)}>
      {children}
    </div>
  )
}

export function CardHeader({ title, subtitle, actions, className }: CardHeaderProps) {
  return (
    <div className={clsx(styles.header, className)}>
      <div className={styles.headerText}>
        <div className={styles.title}>{title}</div>
        {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
      </div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  )
}

export function CardContent({ children, className }: CardContentProps) {
  return <div className={clsx(styles.content, className)}>{children}</div>
}
